<template>
    <edit></edit>
</template>
<script>
    import edit from './media_catalog_edit.vue'

    export default {
        name: 'media_catalog_add',

        components: {
            edit
        }
    }
</script>
